import React from "react";

const StaffHeader = ({ title }) => {
  const staff = JSON.parse(localStorage.getItem("staff") || "{}");

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          <div className="flex items-center space-x-4">
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900">{staff.name}</p>
              <p className="text-xs text-gray-500">{staff.email}</p>
            </div>
            <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center">
              <span className="text-sm font-medium text-gray-600">
                {staff.name ? staff.name[0].toUpperCase() : "S"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default StaffHeader;
